import axios from 'axios'

// const url = `http://localhost:4000`
const url = `https://api.careerroshi.com`


export const FetchOrganizations = async (page, limit, search, sort, filter = '') => {
    let result = await axios.get(`${url}/organizations/list`, { params: { page, limit, search, sort, filter } })
    return result
}

export const AddOrganization = async (body) => {
    let result = await axios.post(`${url}/organizations/add-organization`, body)
    return result
}

export const UpdateOrganization = async (id,body) => {
    let result = await axios.put(`${url}/organizations/update-organization/${id}`, body)
    return result
}
export const FetchUsersList = async (page, limit, search, sort, filter = '') => {
    let result = await axios.get(`${url}/alluserlist`, { params: { page, limit, search, sort, filter } })
    return result
}

export const FetchCoachSearchList = async (search) => {
    let result = await axios.get(`${url}/searchCoach`, { params: { search } })
    return result.data
}

export const FetchJobSeekerCoach = async (id) => {
    let result = await axios.get(`${url}/jobSeekerCoach/${id}`)
    return result.data
}

export const FetchJobSeekerByCoach = async (id) => {
    let result = await axios.get(`${url}/jobSeekerlist-by-coach/${id}`)
    return result.data
}

export const FetchDbStats = async () => {
    let result = await axios.get(`${url}/stats`)
    return result.data
}

export const AssignNewCoach = async (body) => {
    let result = await axios.post(`${url}/assignCoach/`, body)
    return result.data
}

export const FetchClient = async (id) => {
    let result = await axios.get(`${url}/user/${id}`)
    return result.data
}

export const UpdateUserAction = async (id, body) => {

    let res = await axios.put(`${url}/update-user/${id}`, body)
    return res.data

}

export const SendUserNewPasswordAction = async (id, body) => {

    let res = await axios.put(`${url}/user/send-new-password/${id}`, body)
    return res.data

}

export const SendOrgUserNewPasswordAction = async (id) => {

    let res = await axios.put(`${url}/org/user/send-new-password/${id}`)
    return res.data

}

export const FetchOrganizationUsersList = async (organization, page, limit, search, sort, filter = '') => {
    let result = await axios.get(`${url}/organizations/alluserlist`, { params: { page, limit, search, sort, filter, organization } })
    return result
}

export const togglePrivateOrg = async (id, type) => {
    let result = await axios.post(`${url}/organization/toggle`, {
        id,
        private: type
    })
    return result;
}